import { LuneThemeNew, staticImagePath, Text } from '@lune-fe/lune-ui-lib'
import { Link } from '@mui/material'
import Box from '@mui/material/Box'
import { FC } from 'react'

import EmptySheet from 'images/empty-sheet.png'
import { downloadSheet } from 'views/CalculateEmissions/Shared/utils'

const { palette } = LuneThemeNew

const EmptyState: FC<{
    sheetId: string
    downloadType: 'fintech' | 'logistics' | 'rfq' | 'logistics_user_template'
}> = ({ sheetId, downloadType }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '800px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 3,
                flexDirection: 'column',
            }}
        >
            <img alt="Empty table" src={staticImagePath(EmptySheet)} width={174} height={120} />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1 / 2,
                    flexDirection: 'column',
                }}
            >
                <Text variant={'h6'}>No calculations succeeded</Text>
                <Text variant={'body2'} sx={{ color: palette.TextSecondary }}>
                    <Link
                        component={'button'}
                        onClick={() => downloadSheet(sheetId, downloadType)}
                        sx={{
                            color: palette.TextSecondary,
                            textDecoration: 'underline',
                            textDecorationColor: palette.TextSecondary,
                            '&:hover': {
                                textDecorationColor: palette.TextSecondary,
                            },
                        }}
                    >
                        Download your results
                    </Link>{' '}
                    to see why the calculations failed.
                </Text>
            </Box>
        </Box>
    )
}

export default EmptyState
